import React from "react";
import styles from "./News.module.css";
import { Reveal } from "../common/Reveal";
import newsImg1 from "../../../../images/MElfa-Robots-Award1.jpg";
import newsImg2 from "../../../../images/ME-FA-and-AA-Team1.jpg";

const NEWS_ITEMS = [
  { caption: "Photo: Mitsubishi Partner Meet, Thailand 2019", text: "Alliance Automation was felicitated during the Mitsubishi Electric Alliance Partner Meet 2019 in Thailand for MELFA robotics promotion. Mr. Pradeep Sharma, MD of Alliance Automation, received the appreciation award from the Mitsubishi team.", link: "Click here for the Facebook update", href: "https://www.facebook.com/197520450260964/photos/pcb.2470417149637938/2470412602971726/?type=3&theater", imageFirst: true, image: newsImg1 },
  { caption: "Photo: Mitsubishi Electric FAID Office Visit", text: "A visiting delegation from Mitsubishi Electric FAID — including the Director, the AGM of Strategic Planning, and the Regional Head North — toured the Alliance Automation office. The agenda included meeting the team and a walkthrough of the robot service area.", link: "Click here for the Facebook update", href: "https://www.facebook.com/197520450260964/videos/449988752233090/?eid=ARCiAn_7z6O8sx0ZwBl2EHkFrTScr1jHQwlgWMM5JkcFRUlnPpt8SZqwNwqWtzW9KN_rge1PJeru8wA8", imageFirst: false, image: newsImg2 },
];

export default function News() {
  return (
    <section className={styles.news} id="news">
      <Reveal className={styles.sectionIntro}>
        <span className={styles.eyebrow}>company updates</span>
        <h2 className={styles.sectionHeading}>Alliance News</h2>
      </Reveal>
      <div className={styles.newsList}>
        {NEWS_ITEMS.map((n, i) => (
          <Reveal key={n.caption} delay={i * 100} className={`${styles.newsItem} ${n.imageFirst ? "" : styles.newsItemReverse}`}>
            <div className={styles.newsImage}>
              <img src={n.image} alt={n.caption} className={styles.newsImg} loading="lazy" />
            </div>
            <div className={styles.newsBody}>
              <p className={styles.newsText}>{n.text}</p>
              <a href={n.href || "#"} target="_blank" rel="noopener noreferrer" className={styles.newsLink}>{n.link}</a>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
